import { twMerge } from 'tailwind-merge';
import MuiButton from '@mui/material/Button';

import { ButtonProps } from './types';
import {
  colorClassname,
  variantClassname,
  gradientBorderClassname,
} from './styles';

export const Button = ({
  children,
  className,
  fullWidth,
  hasMinWidth,
  textClassName,
  buttonClassName,
  color = 'primary',
  variant = 'contained',
  ...props
}: ButtonProps) => {
  const baseClasses = variantClassname[variant];
  const colorClasses = colorClassname[color]?.[variant];
  const gradientBorderClasses =
    variant === 'outlined' && gradientBorderClassname[color]?.[variant];

  return (
    <span
      className={twMerge(
        'inline-flex align-middle',
        gradientBorderClasses,
        fullWidth && 'w-full',
        className
      )}
    >
      <MuiButton
        disableRipple
        className={twMerge(
          `h-12 w-full rounded-2xl px-4 py-3 normal-case`,
          baseClasses,
          colorClasses,
          buttonClassName,
          hasMinWidth && 'min-w-0'
        )}
        {...props}
      >
        <span className={twMerge('text-base font-semibold', textClassName)}>
          {children}
        </span>
      </MuiButton>
    </span>
  );
};
